module.exports = __webpack_public_path__ + "img/foreign-outbounds.ec93446b.png";